// src/components/DashboardLayout.jsx
import React from "react";
import { Outlet } from "react-router-dom";
import HeaderPremium from "./HeaderPremium";
import FooterPremium from "./FooterPremium";

export default function DashboardLayout() {
  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    window.location.href = "/";
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        backgroundColor: "var(--page-bg)",
      }}
    >
      <HeaderPremium onLogout={handleLogout} />

      <main style={{ flex: 1 }}>
        <div className="zedro-page">
          <div className="container">
            <Outlet />
          </div>
        </div>
      </main>

      <FooterPremium variant="app" />
    </div>
  );
}